<template>
    <v-container v-if="cashRegisters.lenght == 0">
        <h4>Žádná licence pro online správu</h4>
    </v-container>
    <v-container v-else>
        <v-layout align-center justify-center>
            <v-flex v-if="$auth.user().UserLevel === 1" class="lg6 sm6">
                <v-autocomplete 
                  outline 
                  v-model="selectedCashRegister" 
                  :items="cashRegisters" 
                  item-value="ip_vpn" 
                  return-object 
                  :filter="customFilter"
                  :search-input.sync="search"
                  label="Výběr pokladny"
                  no-data-text="Pokladna nenalezena"
                  :disabled="protocolType === 'sdrv'"
                  :loading="isLoading"
                  >
                    <template slot="selection" slot-scope="data">
                        <!-- HTML that describe how select should render selected items -->
                        {{ data.item.sn }} - {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                        <!-- HTML that describe how select should render items when the select is open -->
                        {{ data.item.sn }} - {{ data.item.name }}
                    </template>
                
                </v-autocomplete>
            </v-flex>
            <v-flex v-else class="lg6 sm6">
                <v-autocomplete 
                  outline 
                  v-model="selectedCashRegister" 
                  :items="cashRegisters" 
                  item-value="ip_vpn" 
                  return-object 
                  :filter="customFilter"
                  label="Výběr pokladny"
                  no-data-text="Pokladna nenalezena"
                  :disabled="protocolType === 'sdrv'"
                  :loading="isLoading"
                  >
                    <template slot="selection" slot-scope="data">
                        <!-- HTML that describe how select should render selected items -->
                        {{ data.item.sn }} - {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                        <!-- HTML that describe how select should render items when the select is open -->
                        {{ data.item.sn }} - {{ data.item.name }}
                    </template>
                
                </v-autocomplete>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex  class="lg3 sm3">
                <v-btn color="primary" @click="switchProtocol" :disabled="!selectedCashRegister">{{$t("přepnout pokladnu")}}</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="lg12 sm12 md12">
                <v-alert
                    :value="mshow"
                    :type="mtype"
                    >
                    <b class="text-lg-center text" style="font-size: large;">{{message}}</b>
                </v-alert>
            </v-flex>
        </v-layout>
        <div>
            <v-tabs v-model="selectedTab">
                <v-tab v-for="(tab, index) in tabs" :key="index">
                    {{ tab }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="selectedTab">
                <v-tab-item v-for="(tab, index) in tabs" :key="index">
                    <v-card flat>
                        <v-card-text>
                            <h3>{{ tab }}</h3>
                            <!-- Content for each tab goes here -->
                            <template v-if="tab === 'Tabulka DPH'">
                                <vat-table @loading="v => loading = v"  :ecr="selectedCashRegister" :sdrv="protocolType ==='sdrv'"/>
                            </template>
                            <template v-if="tab === 'Tabulka skupin'">
                                <department-table @loading="v => loading = v" :ecr="selectedCashRegister" :sdrv="protocolType ==='sdrv'" />
                            </template>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    
    <v-dialog v-model="loading" fullscreen full-width>
    <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
        <v-progress-circular
            :size="100"
            :width="7"
            indeterminate
            color="primary">
        </v-progress-circular>
        </v-layout>
  </v-container>
</v-dialog>
</v-container>
</template>

<script>
import VatTable from '@/components/VatTable.vue'
import DepartmentTable from '@/components/DepartmentTable.vue'

export default {
    /*eslint-disable */
    name: 'devices-mgmt',
    data() {
        return {
            selectedCashRegister: null,
            cashRegisters: [],
            selectedTab: 0,
            tabs: ["Tabulka DPH", "Tabulka skupin"],
            mshow: true,
            mtype: 'primary',
            message: this.$t('Pokladna v prodejním módu'),
            protocolType: 'raspi',
            loading: false,
            search: null,
            isLoading: false
        }
    },
    components: {
        VatTable,
        DepartmentTable,
    },
    async mounted() {
        await this.loadECRs()
    },
    watch: {

        async search (val) {
        // Items have already been loaded
        if (this.cashRegisters.length > 0) return

        const ul = this.$auth.user().UserLevel
        if(ul !== 1) return

        try {
            this.isLoading = true
            let res = await this.axios.get(`/api/ecr-licensed?userlevel=${ul}&pattern=${val}`) 
            this.cashRegisters = res.data
            
        } catch (e){

            console.log(e)
            this.$root.$gerror(e.response.data)
          
        } finally {
            this.isLoading = false
        }
      }

    },
    methods: {
        customFilter (item, queryText, itemText) {
        const textOne = item.name.toLowerCase()
        const textTwo = item.sn.toLowerCase()
        const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1 ||
            textTwo.indexOf(searchText) > -1
        },
        protocolToogle(isSrdv) {
            if (isSrdv) {
                this.mtype = 'warning'
                this.message = this.$t('Pokladna v PROGRAMOVACÍM módu')
                this.protocolType = "sdrv"
            } else {
                this.mtype = 'primary'
                this.message = this.$t('Pokladna v prodejním módu')
                this.protocolType = "raspi"
            }

        },
        async switchProtocol() {
            try {
                this.loading = true
                let response = await this.axios.get(`/api/ecr-switchprotocol?ip=${this.selectedCashRegister.ip_vpn}&current=${this.protocolType}`)
                this.protocolToogle(response.data.is_sdrv)
            } catch (e) {
                console.log(e)
                this.$root.$gerror(e.response.data)
            } finally {
                this.loading = false
            }
        },
        async loadECRs() {
            if(this.$auth.user().UserLevel === 1) return

            try {
                console.log(this.$auth.user())
                this.loading = true
                let res = null
                res = await this.axios.get(`/api/ecr-licensed/`)
                this.cashRegisters = res.data
            } catch (e) {
                this.$root.$gerror(e.response.data)
            } finally {
                this.loading = false
            } 
        },
    }
}
</script>

<style>
/* Add your custom styles here */
</style>
                                

